import { Components, Theme } from '@mui/material';

import { fontFamily, fontWeight } from '../constants/fonts';

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    primary1000: true;
    primary900: true;
    primary800: true;
    primary200: true;
  }
  interface ButtonPropsVariantOverrides {
    link: true;
    linkBold: true;
  }
}

export const buttonConfigs: Components<Theme>['MuiButton'] = {
  defaultProps: {
    disableElevation: true,
    disableFocusRipple: true,
    disableRipple: true,
    variant: 'contained',
    color: 'primary',
  },
  variants: [
    {
      props: { variant: 'link' },
      style: ({ theme }) => ({
        padding: 0,
        height: 'unset',
        fontWeight: fontWeight.regular,

        '.MuiButton-startIcon': {
          marginRight: theme.spacing(2),
        },
        '.MuiButton-endIcon': {
          marginLeft: theme.spacing(2),
        },

        ':hover': {
          backgroundColor: 'unset',
          color: theme.palette.primary.main,

          '.MuiButton-startIcon, .MuiButton-endIcon': {
            '.MuiSvgIcon-root': {
              fill: theme.palette.primary.main,
            },
          },
        },
      }),
    },
    {
      props: { variant: 'linkBold' },
      style: ({ theme }) => ({
        padding: 0,
        height: 'unset',
        fontSize: theme.typography.body2Bold.fontSize,
        fontWeight: theme.typography.body2Bold.fontWeight,

        '.MuiButton-startIcon': {
          marginRight: theme.spacing(2),
        },
        '.MuiButton-endIcon': {
          marginLeft: theme.spacing(2),
        },

        ':hover': {
          backgroundColor: 'unset',
          color: theme.palette.primary.main,

          '.MuiButton-startIcon, .MuiButton-endIcon': {
            '.MuiSvgIcon-root': {
              fill: theme.palette.primary.main,
            },
          },
        },
      }),
    },
    {
      props: { variant: 'outlined' },
      style: ({ theme }) => ({
        '&:hover': {
          backgroundColor: theme.palette.common.white,
          color: theme.palette.common.black,
          border: `1px solid ${theme.palette.common.black}`,
        },
      }),
    },
  ],
  styleOverrides: {
    root: ({ theme }) => ({
      paddingLeft: 18,
      paddingRight: 18,
      fontFamily: fontFamily.primary,
      fontWeight: fontWeight.semiBold,
      lineHeight: 1.3,
      textTransform: 'initial',
      height: 44,

      '.MuiButton-startIcon': {
        marginRight: theme.spacing(0.75),
        '.MuiButtonBase-root': {
          padding: 0,
        },
      },
      '.MuiButton-endIcon': {
        marginLeft: theme.spacing(0.75),
        '.MuiButtonBase-root': {
          padding: 0,
        },
      },
    }),
    contained: ({ theme }) => ({
      ':active': {
        backgroundColor: theme.palette.primaries[400],
      },
      '.MuiButton-startIcon, .MuiButton-endIcon': {
        '.MuiSvgIcon-root': {
          fill: theme.palette.primary.contrastText,
        },
      },
    }),
    text: ({ theme }) => ({
      color: theme.palette.text.primary,
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      paddingBottom: theme.spacing(0.75),
      paddingTop: theme.spacing(0.75),
    }),
    outlined: ({ theme }) => ({
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.primary1000.main,
      borderColor: theme.palette.primary1000.main,
      ':hover': {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.primaries[100],
      },
      ':active': {
        backgroundColor: theme.palette.primaries[100],
      },
    }),
  },
};
